import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { ProductTypeEditorController } from '../../products/parts/product-type-editor.controller';

export class ProductCategoryListView extends React.Component<ProductCategoryListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: ProductCategorySummary) => <Link to={`/products/categories/${record.id}`}>{text}</Link>,
			},
			{
				key: 'productTypeText',
				title: 'Product type',
				dataIndex: 'productTypeText',
				filter: {
					field: 'productType',
					type: 'foreignKey',
					render: (value, onChange) => (
						<ProductTypeEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={onChange}
							setBusy={this.props.setBusy}
						/>
					)
				}
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						hierarchyId={['id']}
						hierarchyParent={['parentCategoryId']}
						hierarchyHasChildren={(item) => item.hasChildren}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/list/product-category-list.view.tsx